import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";
import Grid from "@mui/material/Grid";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import { makeStyles } from "@material-ui/core/styles";
import { currentAssetSliceActions } from "../../../Store/Slices/CurrentAssetSlice";
import OptionsCard from "../../../Components/Card/AssetUI/OptionsCard";

var initLogObj = {
  attempts: 1,
  duration: 0,
  assetType: {
    group: "practice",
    value: null,
  },
  userAnswer: [],
  isEvaluated: "auto",
  actualAnswer: [],
  genericScore: 0,
};

const statePair = {
  0: "True | False",
  1: "Yes | No",
  2: "Correct | Incorrect",
  3: "Positive | Negative",
  4: "On | Off",
  5: "Valid | Invalid",
  6: "1 | 0",
};

const TF = (props) => {
  // Hooks
  const dispatch = useDispatch();
  const classes = useStyles();

  // State
  const [userAnswer, setUserAnswer] = useState([]);
  const [logObj, setLogObj] = useState(initLogObj);
  const [currentOptionIndex, setCurrentOptionIndex] = useState(0);

  // Redux state
  const { showAnswer, assetLogObj, attempted, currentAttempt, optionWiseAns } = useSelector(
    (state) => state.currentAsset
  );

  useEffect(() => {
    if (props.content) {
      setUserAnswer(
        new Array(props.content.epage.options.content.length).fill(null)
      );
      dispatch(
        currentAssetSliceActions.setCurrentAttemptData(
          new Array(props.content.epage.options.content.length).fill(null)
        )
      );
      let actualAnswers = props.content.epage.options.content.map((val) => {
        if (val.answer) return JSON.parse(val.answer);
        else return JSON.parse("false");
      });
      setLogObj({
        ...logObj,
        assetType: {
          ...logObj.assetType,
          value: props.content.info.asset_type_alias,
        },
        actualAnswer: actualAnswers,
      });
    }
  }, [props.content]);

  useEffect(() => {
    dispatch(currentAssetSliceActions.setAssetLogObj(logObj));
    dispatch(currentAssetSliceActions.setShowAnswer(false));
    setCurrentOptionIndex(0);
  }, [logObj]);

  useEffect(() => {
    setUserAnswer(
      new Array(props.content.epage.options.content.length).fill(null)
    );
    dispatch(currentAssetSliceActions.setShowAnswer(false));
    dispatch(
      currentAssetSliceActions.setCurrentAttemptData(
        new Array(props.content.epage.options.content.length).fill(null)
      )
    );
    setCurrentOptionIndex(0);
  }, [currentAttempt]);

  useEffect(() => {
    console.log("showAnswer", showAnswer);
    if (showAnswer && assetLogObj && assetLogObj.actualAnswer) {
      setUserAnswer(assetLogObj.actualAnswer);
      let firstTrueIndex = assetLogObj.actualAnswer.indexOf(true);
      console.log("firstTrueIndex", firstTrueIndex);
      setCurrentOptionIndex(firstTrueIndex);
    }
  }, [showAnswer, assetLogObj]);

  useEffect(() => {
    return () => {
      setUserAnswer([]);
    };
  }, []);

  const updateUserAnswer = (index, flag) => {
    if (!showAnswer && !attempted) {
      let newArray = [...userAnswer];
      if (newArray[index] == flag) {
        newArray[index] = null;
      } else {
        newArray[index] = flag;
      }
      setUserAnswer(newArray);
      dispatch(currentAssetSliceActions.setCurrentAttemptData(newArray));
    }
  };

  return (
    <div  >
      {props.content &&
        props.content.epage.options.content.map((item, index) => {
          return (
            <OptionsCard
              text={item.text}
              media={item.media}
              index={index}
              selected={userAnswer[index]}
              totalOptions={props.content.epage.options.content.length}
              press={(selectedIndex, flag) => {
                updateUserAnswer(selectedIndex, flag);
              }}
              statePair={
                isNaN(+props.content.info.state_pair)
                  ? props.content.info.state_pair
                  : statePair[+props.content.info.state_pair]
              }
              assetType={props.content.info.asset_type_alias}
              optionWiseAns={optionWiseAns[index]}
            />
          );
        })}
    </div>
  );
};

const useStyles = makeStyles({
  ListItemText: {
    fontSize: "1rem !important",
  },
  scrollBar: {
    "&::-webkit-scrollbar": {
      width: "0.2em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
    height: "62vh",
    overflow: "auto",
  },
  scrollBarHeight: {
    "&::-webkit-scrollbar": {
      height: "0.2em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
  },
});

export default TF;
